import BookIcon from "@redotech/redo-icons/book-open-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-views-common/advanced-filters/generic-advanced-filter-data";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export function getCustomFieldStringFilter(
  key: string,
  displayName: string,
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<string[]>,
): AdvancedTableFilter {
  return {
    type: AdvancedFilterType.ARRAY_TO_STRING,
    operators: [
      ArrayStringFilterOperator.NONE_OF,
      ArrayStringFilterOperator.ANY_OF,
      ArrayStringFilterOperator.ALL_OF,
    ],
    data: {
      name: key,
      type: AdvancedFilterType.ARRAY_TO_STRING,
      value: [],
      operator: ArrayStringFilterOperator.ANY_OF,
    },
    itemLabel: "text",
    Icon: BookIcon,
    valueFetcher: fetcher,
    displayName,
    dbSearch: false,
  };
}
